<div class="toaster" *ngIf="toasts.length" role="region" aria-live="polite">
    <div class="toast" *ngFor="let t of toasts" [ngClass]="t.type" [attr.data-id]="t.id">
        <div class="toast-left">
            <mat-icon class="toast-icon">{{ iconForType(t.type) }}</mat-icon>
        </div>
        <div class="toast-body">
            <div class="toast-message">{{ t.message }}</div>
            <div class="toast-meta">
                <button class="close" (click)="dismiss(t.id)" aria-label="Dismiss">✕</button>
            </div>
        </div>
        <div class="progress" [style.animationDuration.ms]="t.duration || 5000"></div>
    </div>
</div>